"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { UserProfileError, UserProfileLoading, UserProfile as UserProfilePresentational, } from "./lib/user-profile";
import { useIsHydrated } from "./lib/use-is-hydrated";
import { ApiProvider, useMe } from "./api";
import { useWorkOsApiUrl } from "./lib/widgets-context";
import { ErrorBoundary } from "./lib/error-boundary";
export const UserProfile = ({ authToken }) => {
    const baseUrl = useWorkOsApiUrl();
    return (_jsx(ApiProvider, { widgetType: "user-profile", authToken: authToken, baseUrl: baseUrl, children: _jsx(UserProfileContent, {}) }));
};
const UserProfileContent = () => {
    const isHydrated = useIsHydrated();
    const meQuery = useMe();
    if (
    // render loading state on the server to prevent FOUC or hydration mismatch
    !isHydrated ||
        meQuery.isLoading) {
        return _jsx(UserProfileLoading, {});
    }
    if (meQuery.isError) {
        return _jsx(UserProfileError, { error: meQuery.error });
    }
    const user = meQuery.data;
    return (_jsx(ErrorBoundary, { FallbackComponent: UserProfileError, children: _jsx(UserProfilePresentational, { userData: user }) }));
};
//# sourceMappingURL=user-profile.client.js.map